import { allTrackers } from "app/services/track/track";

export const trademarksTracking = {
    onPrefillClick: (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "Prefill trademarks");
    },
    onAddTrademarkClick: (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "Add Trademark");
    },
    onExcelDownload: (): void => {
        allTrackers.dispatchTrackEvent("Button", "download", "Download excel");
    },
    onCreateTrademarkSave: (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "Save Trademark");
    },
};
